if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }







      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

          const bundleId = `bundle_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
        formData.append('properties[_bundle_id]', bundleId);
        
        // new code 
        
          const giftWrapChecked = document.getElementById("gift-wrap-checkbox")?.checked;
          const juteBagChecked = document.getElementById("jute-bag-checkbox")?.checked;

          const giftWrapVariantId = document.getElementById("gift-wrap-variant-id")?.value;
          const juteBagVariantId = document.getElementById("jute-bag-variant-id")?.value;

          const bagQty = document.getElementById("jute-bag-quantity")?.value || 1;
          // const bagQty = Number(document.getElementById("jute-bag-quantity")?.value || 1);

          console.log({
          mainVariant: formData.get("id"),
          giftWrapChecked,
          juteBagChecked,
          giftWrapVariantId,
          juteBagVariantId,
          bagQty,
          });
         // new code 






        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
      
        config.body = formData;
        
          // new code 
          const items = [
          {
          id: formData.get('id'),
          quantity: Number(formData.get('quantity')) || 1,
           properties: {
      _bundle_id: bundleId
    }
          },
          ];
         
          if (giftWrapChecked && giftWrapVariantId) {

            
            
          items.push({
          id: giftWrapVariantId,
          quantity: 1,
          });
          }

          if (juteBagChecked && juteBagVariantId) {
          items.push({
          id: juteBagVariantId,
          quantity: Number(bagQty),
           properties: {
    _bundle_id: bundleId
        }
          });
          }

          console.log(items);
          // new code 
fetch(`${routes.cart_add_url}.js`, {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  body: JSON.stringify({
    items: items,
    sections: this.cart
      ? this.cart.getSectionsToRender().map((section) => section.id)
      : [],
    sections_url: window.location.pathname,
  }),
})
  .then((response) => response.json())
  .then((response) => {

    console.log(response);


 if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }


    // 👇 Ye line add karo
    if (this.cart) {
      this.cart.renderContents(response);
    }

    return response;

  })

       




          // .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
               
              // cart upsell slick initialized
                setTimeout(() => {

                window.initSlickSlider('.cart-upsell__slider', {
                slidesToShow: 1
                });

                $('.cart-upsell').addClass('upsell-loaded');

                }, 900);
                // cart upsell slick initialized


              // alert('ok');
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
                
                // cart upsell slick initialized
                setTimeout(() => {

                window.initSlickSlider('.cart-upsell__slider', {
                slidesToShow: 1
                });

                $('.cart-upsell').addClass('upsell-loaded');

                }, 900);
                // cart upsell slick initialized

              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }




      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
